import { api } from "../api";

type DriverTransferType = {
    customerId: number;
    secretaryId: number;
    currentDepartmentId: number;
    targetDepartmentId: number;
    drivers: Array<string>;
    isSharing: boolean;
};

/**
 * updateDriverDepartment - Function that updates the department of an existing driver
 * /drivers/departments
 * method PUT  
 * @async-function
 */
const updateDriverDepartment = async (token: string, model: DriverTransferType) => {    
    const response = await api.put(
        `/drivers/departments`, { ...model }, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default updateDriverDepartment;
